module.exports = __webpack_public_path__ + "img/doctor_default_avatar@2x.ed5abdb6.png";